// src/utils/admin/customer/customerhelper.js

/**
 * Generate avatar initial from name
 * @param {string} name - Customer name
 * @returns {string} First letter of name
 */
export const getAvatarInitial = (name) => {
  return name ? name.charAt(0).toUpperCase() : "?";
};

/**
 * Format currency (PKR)
 * @param {number} amount - Amount to format
 * @returns {string} Formatted currency
 */
export const formatCurrency = (amount) => {
  return `Rs. ${parseFloat(amount).toLocaleString()}`;
};

/**
 * Calculate customer statistics
 * @param {array} customers - Array of customers
 * @returns {object} Statistics
 */
export const calculateCustomerStats = (customers) => {
  const stats = {
    total: customers.length,
    active: 0,
    totalRevenue: 0,
    totalOrders: 0,
  };

  customers.forEach((customer) => {
    if (customer.status === "active") stats.active++;
    stats.totalRevenue += parseFloat(customer.totalSpent || 0);
    stats.totalOrders += parseInt(customer.orders_count || 0);
  });

  return stats;
};

/**
 * Search customers
 * @param {array} customers - Array of customers
 * @param {string} searchTerm - Search query
 * @returns {array} Filtered customers
 */
export const searchCustomers = (customers, searchTerm) => {
  if (!searchTerm) return customers;

  const term = searchTerm.toLowerCase();
  return customers.filter(
    (customer) =>
      customer.name?.toLowerCase().includes(term) ||
      customer.email?.toLowerCase().includes(term) ||
      customer.phone?.toLowerCase().includes(term),
  );
};

/**
 * Filter customers by status
 * @param {array} customers - Array of customers
 * @param {string} status - Status filter
 * @returns {array} Filtered customers
 */
export const filterCustomersByStatus = (customers, status) => {
  if (!status || status === "all") return customers;
  return customers.filter(
    (customer) => customer.status?.toLowerCase() === status.toLowerCase(),
  );
};
